<script>
    import TopbarSection from '../../../components/pagesbuilder/sections/TopbarSection.vue';
    import PreviewSection from "../PreviewSection";

    export default {
        name: "PreviewTopbarSection",
        mixins: [PreviewSection,TopbarSection]
    }
</script>
